import type { SxProps, Theme } from '@mui/material';

/** The envelope cards' minimum width (visual contract §7). */
export const DEFAULT_MIN_CARD_WIDTH = 272;

/** The account cards' minimum width (visual contract §7). */
export const ACCOUNT_MIN_CARD_WIDTH = 258;

/**
 * A card grid by minimum width (TMMAPP-0099, visual contract §7): as many columns as fit at
 * `minCardWidth`, gap 16. Every card grid in the app uses this rule (replacing 0096's fixed
 * 1 / 2 / 3 columns).
 */
export function cardGridSx(
  extra?: SxProps<Theme>,
  minCardWidth: number = DEFAULT_MIN_CARD_WIDTH,
): SxProps<Theme> {
  return [
    {
      display: 'grid',
      gap: 2,
      // `min(…, 100%)`: a container narrower than one card (a padded card, 320px reflow) gets one
      // full-width column instead of overflowing.
      gridTemplateColumns: `repeat(auto-fill, minmax(min(${minCardWidth}px, 100%), 1fr))`,
      alignItems: 'stretch',
    },
    ...(extra === undefined ? [] : Array.isArray(extra) ? extra : [extra]),
  ];
}
